import {
    NOTIFICATION_BAR_UPDATE_HEIGHT,
    PAGE_NOTIFICATION_BAR_ITEM_GENERATED,
    PAGE_NOTIFICATION_BAR_ITEM_REMOVED,
} from "../action_types/common_action_types";

export const updateNotificationBarHeight = (height: number) => {
    return {
        type: NOTIFICATION_BAR_UPDATE_HEIGHT,
        height,
    };
};

const createPageNotificationBar = (notification: FixmeType) => {
    return {
        type: PAGE_NOTIFICATION_BAR_ITEM_GENERATED,
        notification,
    };
};

const removePageNotificationBar = (notificationId: string) => {
    return {
        type: PAGE_NOTIFICATION_BAR_ITEM_REMOVED,
        notificationId,
    };
};
